// Shared industry id -> display label map, used by the Solutions pages
// (SolutionsPage.jsx / IndustryPage.jsx) and by the Book-a-Demo form so the
// "Industry" field can be pre-selected when a visitor books a demo from a
// dedicated industry page.
export const INDUSTRY_LABELS = {
  banking: "Banking & Financial Services",
  manufacturing: "Manufacturing & Distribution",
  retail: "Retail & Consumer",
  healthcare: "Healthcare & Life Sciences",
  tech: "Technology & Professional Services",
};

export const INDUSTRY_IDS = Object.keys(INDUSTRY_LABELS);
